YP.EventPromotionsManager = function() {
    return {
        init: function() {
            if($('#event_promotion_table').length > 0) {

               $('a.promo-code').live('click', function() {
                   var target = '.promo-code-' + $(this).attr('id');
                   $(target).toggle();
               });
            }
        },
        addPromoInput: function ($checkbox) {
            var type = $checkbox.val();
            if (type == 1 || type ==2 ) {
                if (type == 1) {
                    add = '%';
                }
                else {
                    add = '€';
                } 
                $('.js-promotion-amount').show();
                $('.js-promotion-amount input').val(null).focus();
                $('.js-promotion-amount .c-form__completion').html(add);

            } else {
                $('.js-promotion-amount').hide();
                $('.js-promotion-amount input').val(null);
            }
        },
        initForm: function() {
            $('.js-promotion-type input:radio').on('click', function(){
                YP.EventPromotionsManager().addPromoInput($(this));
            });

            $('form.js-ticket-promotion button[type=submit]').click(function(){
                var type = $('form.ticketpromotion .promotype input:checked').val();
                if (type && (type == 1 || type == 2)) {
                    var val = $('form.ticketpromotion .promotion input').val();
                    var val = val.replace(",", ".");
                    $('form.ticketpromotion .promotion input').val(val);
                }
                return true;
            });

            if($("#code_invitation_handsontable").length > 0){
                YP.HandsontableManager().initInvitationCodeManager();
            }
            if($("#code_invitation_import_handsontable").length > 0){
                YP.HandsontableManager().initInvitationCodeImportManager();
            }
        },
        initFormCampaign: function(){
            const form = $('.js-form_campaign_ticket_promotion');
            form.find('.js-check_type_ticket').on('change', function(e){
                $('.js-display_promo_type_ticket').toggle();
            })

            form.find('.js-promo_type').on('change', function(e) {
                if($(this).find('input').hasClass('js-promo_type_percent')) {
                    $('.js-promo_type_money').val(null);
                    $('.js-promo_type_free').prop('checked', false);
                } else if ($(this).find('input').hasClass('js-promo_type_money')) {
                    $('.js-promo_type_percent').val(null);
                    $('.js-promo_type_free').prop('checked', false);
                } else {
                    $('.js-promo_type_money').val(null);
                    $('.js-promo_type_percent').val(null);
                }
            })
        },
    };
};

window.addEventListener("load", function(){

    if($('form.js-ticket-promotion').length > 0) {
        YP.EventPromotionsManager().initForm();
    }
    if($('#event_promotion_table').length > 0) {
        YP.EventPromotionsManager().init();
    }
});
